module.exports = __webpack_public_path__ + "static/media/4.ae979102.png";